// Write your code here
import './index.css'

import {Component} from 'react'

import Loader from 'react-loader-spinner'
import TeamCard from '../TeamCard'

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

class Home extends Component {
  state = {isLoading: true, dataList: []}

  componentDidMount() {
    this.teamsApiUrl()
  }

  teamsApiUrl = async () => {
    const response = await fetch('https://apis.ccbp.in/ipl')
    const datas = await response.json()

    const modifiedList = datas.teams.map(every => ({
      name: every.name,
      id: every.id,
      teamImageUrl: every.team_image_url,
    }))

    this.setState({dataList: modifiedList, isLoading: false})
  }

  toRender = () => {
    const {dataList} = this.state
    return (
      <div className="HomeContainer">
        <div className="logoContainer">
          {' '}
          <img
            className="logoImage"
            alt="ipl logo"
            src="https://assets.ccbp.in/frontend/react-js/ipl-logo-img.png"
          />
          <h1 className="logoHeading">IPL Dashboard</h1>
        </div>
        <ul className="home_2">
          {dataList.map(every => (
            <TeamCard key={every.id} details={every} />
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const {isLoading} = this.state
    return isLoading ? (
      <div>
        {' '}
        <Loader type="Oval" color="#ffffff" height={50} width={50} />{' '}
      </div>
    ) : (
      this.toRender()
    )
  }
}
export default Home
